/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Internal dependencies
 */
import PanelTypes from './panelTypes';

export enum STYLE_PANE_IDS {
  Selection = 'selection',
  Link = 'link',
  Animation = 'animation',
}

const { Link, Animation, ...panelsExcludingLinkAndAnimation } = PanelTypes;

export const PanelSections = {
  [STYLE_PANE_IDS.Selection]: Object.values(panelsExcludingLinkAndAnimation),
  [STYLE_PANE_IDS.Link]: [Link],
  [STYLE_PANE_IDS.Animation]: [Animation],
};
